var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11325_187518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.46959 3.75637H6.45725V4.74402H5.46959V3.75637ZM5.46959 5.73168H6.45725V8.69464H5.46959V5.73168ZM5.96342 1.28723C3.23749 1.28723 1.02515 3.49958 1.02515 6.2255C1.02515 8.95143 3.23749 11.1638 5.96342 11.1638C8.68934 11.1638 10.9017 8.95143 10.9017 6.2255C10.9017 3.49958 8.68934 1.28723 5.96342 1.28723ZM5.96342 10.1761C3.78564 10.1761 2.0128 8.40328 2.0128 6.2255C2.0128 4.04773 3.78564 2.27489 5.96342 2.27489C8.1412 2.27489 9.91404 4.04773 9.91404 6.2255C9.91404 8.40328 8.1412 10.1761 5.96342 10.1761Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11325_187518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.8519,
    height: 11.8519,
    fill: "white",
    transform: "translate(0.0373535 0.299316)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipWhite);
export default __webpack_public_path__ + "static/media/tooltip_white.69ad735b602b4822cc9ec944367ea531.svg";
export { ForwardRef as ReactComponent };